function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.838 0a1.943 1.943 0 011.717 1.04l1.216 2.515a1.993 1.993 0 01-.293 2.272L8.377 11.4l-.006.006c-.355.38-.852.596-1.37.594a1.867 1.867 0 01-1.372-.593l-.005-.006L.52 5.826A1.993 1.993 0 01.23 3.555L1.445 1.04A1.943 1.943 0 013.162 0h7.676zm0 1.107H3.162a.846.846 0 00-.737.432l-1.213 2.51-.01.018a.88.88 0 00.125 1.008l5.1 5.572a.79.79 0 001.146 0l5.1-5.571a.88.88 0 00.115-1.028l-1.213-2.51a.846.846 0 00-.737-.431zM9.502 3.936a.575.575 0 01.124.803c-.8 1.093-1.707 1.647-2.7 1.647-1.647 0-2.82-1.58-2.87-1.647a.575.575 0 01.926-.68c.008.012.883 1.177 1.945 1.177h.004C7.535 5.234 8.13 4.839 8.7 4.06a.574.574 0 01.803-.124z",
  fill: "#31C4CC",
  fillRule: "nonzero"
});

var SvgIcLoginVip = function SvgIcLoginVip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12
  }, props), _ref);
};

export default SvgIcLoginVip;